import { render, staticRenderFns } from "./AFUserManagementScreen.vue?vue&type=template&id=8c534350&scoped=true&"
import script from "./AFUserManagementScreen.vue?vue&type=script&lang=js&"
export * from "./AFUserManagementScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c534350",
  null
  
)

export default component.exports